module.exports = __webpack_public_path__ + "static/media/caros-thin.d0f4547d.woff";